import { Text, VStack } from 'ui_2';
import { NewUserQuests } from '../newUserQuests/NewUserQuests';
import { DailyStats } from '../streak/DailyStats';
import { ReferralQuestRow } from '../quests/ReferralQuestRow';
import { GoToGiveaways } from '../GoToGiveaways';
import { ProductSkuCards } from '../rewards/ProductSkuCards';
import { QuestBentos } from '../quests/QuestBentos';
import { renderParcTitle } from '@src/data/utils';

export const HomePageContents = () => {
  return (
    <VStack className='w-full items-center gap-4'>
      <NewUserQuests />
      <DailyStats />
      <div className='flex w-full flex-col items-center justify-center gap-4 md:flex-row'>
        <div className='w-full max-w-[500px] md:w-1/2'>
          <ReferralQuestRow />
        </div>
        <div className='w-full max-w-[500px] md:w-1/2'>
          <GoToGiveaways />
        </div>
      </div>
      <ProductSkuCards />
      <VStack className='w-full gap-2'>
        <Text font='bold-sm'>{renderParcTitle('Earn PARC')}</Text>
        <QuestBentos />
      </VStack>
    </VStack>
  );
};
